import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import SummaryWrapper from "./Summary.style";
import {
  getPaymentById,
  verifyTamaraOrder,
} from "../../../../services/renewal-service";
import { useDispatch, useSelector } from "react-redux";
import { generateSha256Hash } from "../../../../helpers/utils";
import { useLocation, useNavigate } from "react-router-dom";

import config from "../../helpers/config";
import * as globalUtils from "../../../../helpers/utils";
import Summarydetailtop from "../../../renewal/components/summaryDetailTop/summarydetailtop";

const Summary = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [policy, setPolicy] = useState(
    location.state
      ? location.state.policyNumber
      : localStorage.getItem("policyNoOld")
  );
  const [policyURL, setPolicyURL] = useState(
    location.state ? location.state.data.policyURL : ""
  );
  const travelGoogleTaggingData = JSON.parse(
    window.localStorage.getItem("travelCred")
  );
  const [paymentData, setPaymentData] = useState(null);
  const checkoutId = window.localStorage.getItem("travelCheckoutId");

  const { businessLine } = useSelector((state) => state.travel);

  let tamara = {};
  let checkout = null;
  let policyNo = null;

  try {
    tamara = JSON.parse(localStorage.getItem("tamaraResponse"));
  } catch (error) {
    console.error("Empty Tamara Object");
  }

  try {
    checkout = localStorage.getItem("checkoutId");
    console.log(checkout);
  } catch (error) {
    console.error("Empty checkout Id");
  }

  try {
    policyNo = localStorage.getItem("policyNoOld");
    console.log(policyNo);
  } catch (error) {
    console.error("Empty policyNo Id");
  }

  console.log(location.state);
  const [policyNumber, setPolicyNumber] = useState(
    location.state ? location.state.policyNumber : ""
  );

  useEffect(() => {
    if (checkout) {
      getPaymentById({ id: checkout }).then((response) => {
        const res = response.data;
        if (res.resultCode === "S") {
          setPolicy(res.policyNo);
          const localData = JSON.parse(
            window.localStorage.getItem("travelCreditcardPaymentData")
          );

          forGoogleTagging(travelGoogleTaggingData);
          setPaymentData(localData);
          setPaymentData(localData);

          setPolicyURL(res.getPaymentDetailsByIdResponse?._links?.self?.href);
          console.log(response);
        } else {
          // navigate(config.paymentFailedRedirect, { replace: false });
        }
      });
    } else if (tamara) {
      const data = {
        systemId: "TR",
        applicationType: "RHSP",
        langCode: globalUtils.getOneLetterLanguageCode(props.i18n.language),
        referenceId: tamara.refId,
        channelCode: businessLine ? "3" : "2",
      };
      verifyTamaraOrder(data).then((response) => {
        const res = response.data;
        if (res.resultCode === "S") {
          setPolicy(res.policyNumber);
        } else {
          // navigate(config.paymentFailedRedirect, { replace: false });
        }
      });
    } else if (policyNo) {
      setPolicy(policyNo);
    } else {
      // navigate(config.paymentFailedRedirect, { replace: false });
    }
  }, [, checkout]);

  useEffect(() => {
    if (travelGoogleTaggingData) {
      forGoogleTagging(travelGoogleTaggingData);
    }
  }, []);

  const forGoogleTagging = async (data, policyNum = "") => {
    const hashedEmail = await generateSha256Hash(data.email);
    const hashedPhone = await generateSha256Hash(data.phone);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "travel_new_purchased_v2",
      item_name: "Travel Insurance New",
      item_category: "Travel Insurance",
      item_class: "Individual",
      funnel_step: "step_8",
      travelling_to: data?.travelling_to,
      travelling_with_family: data?.travelling_with_family,
      travelling_with_friends: data?.travelling_with_family,
      num_travellers: +data?.num_travellers,
      num_days: +data?.num_days,
      fursan_membership: data?.fursan_mempership || "No",
      sha_256_email: hashedEmail,
      sha_256_phone: hashedPhone,
      policy_id: policyNum || policyNumber,
      items: [
        {
          name: data?.itemName,
          id: data?.travelling_to_id,
          price: parseFloat(data?.itemPrice),
        },
      ],
      ecommerce: {
        transaction_id:
          data?.selected_payment_method === "Sadad" ? checkoutId : checkoutId,
        value: parseFloat(data?.itemPrice),
        tax: parseFloat(data?.tax),
        shipping: 0.0,
        currency: "SAR",
        coupon: data?.coupon || "",
        payment_method: data?.selected_payment_method,
        items: [
          {
            item_id: data?.travelling_to_sub_id,
            item_name: data?.travelling_to,
            item_category: "Travel Insurance",
            item_category2: "Travel Insurance New",
            item_variant: data?.itemName,
            price: parseFloat(data?.itemPrice),
            quantity: 1,
          },
        ],
      },
    });
  };
  useEffect(() => {
    if (travelGoogleTaggingData) {
      if (Boolean(Object.keys(travelGoogleTaggingData).length)) {
        setPaymentData(travelGoogleTaggingData);
      }
    }

  }, [travelGoogleTaggingData]);

  return (
    <SummaryWrapper>
      <div className="Summary-wrapper">
        <div className="summary-top-section col-12">
          <Summarydetailtop travel={true} policy={policy} url={policyURL} />
        </div>
        <div className="vehical-section col-12"></div>
      </div>
      <img src="https://disruptive.gotrackier.com/pixel?adid=65d30fe0be930e78dc70ea33" />
    </SummaryWrapper>
  );
};
//export default withTranslation()(connect(Summary));
export default withTranslation()(Summary);
